<!-- https://www.figma.com/file/reAk2sU4YpRajpQu2YBOHk/007%2F1.-%D0%AD%D0%BB%D0%B5%D0%BC%D0%B5%D0%BD%D1%82%D1%8B?type=design&node-id=162%3A86994&t=CqICr9TzSES2BMqL-1 -->
<template>
  <div class="read-also">
    <div class="read-also__container">
      <div class="read-also__header">
        <div class="read-also__title">
          {{ readAlso.title }}
        </div>
        <div
          v-if="readAlso.emoji"
          class="read-also__emoji"
        >
          {{ readAlso.emoji }}
        </div>
      </div>
      <div class="articles">
        <div
          v-for="(item, index) in items"
          :key="index"
          class="articles__item"
        >
          <TheLink
            class="articles__item-text"
            :link="item.url || ''"
            target="_blank"
          >
            {{ item.title }}
          </TheLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import TheLink from '~/components/TheLink.vue';
  import type { IContentReadAlso, TReadAlso, TReadAlsoItem } from '~/types/components/ReadAlso';
  import getSlugFromUrl from '~/utils/getSlugFromUrl';

  export default defineNuxtComponent({
    components: {
      TheLink,
    },

    props: {
      elem: {
        type: Object as PropType<IContentReadAlso>,
        required: true,
      },
    },

    computed: {
      readAlso(): TReadAlso {
        return this.elem.attributes;
      },

      items(): Array<TReadAlsoItem> {
        return this.readAlso.items?.filter((item) => !!item.title) || [];
      },

      currentslug(): string {
        return getSlugFromUrl(this.$route.fullPath);
      },
    },

    methods: {},
  });
</script>

<style lang="scss" scoped>
  .read-also {
    border-left: 1px solid #e7e7e7;
    border-right: 1px solid #e7e7e7;
    border-bottom: 1px solid #e7e7e7;
    margin: 24px 0px;

    &::before {
      content: '';
      display: block;
      position: relative;
      top: 0;
      left: -1px;
      width: calc(100% + 1px + 1px);
      border-top: 3px solid var(--main-color);
    }

    &__container {
      padding: 12px 16px 24px;
      position: relative;

      @include tablet {
        padding: 16px 24px 32px;
      }
    }

    &__header {
      display: flex;
      justify-content: space-between;
      align-items: center;

      font-family: $secondFont;
      font-weight: 600;

      margin-bottom: 12px;

      @include tablet {
        margin-bottom: 16px;
      }
    }

    &__title {
      @include mediumText;
      word-break: break-word;

      @include tablet {
        @include bigText;
      }
    }

    &__emoji {
      @include bigText;
    }
  }

  .articles {
    &__item {
      & + & {
        margin-top: 12px;

        @include desktop {
          margin-top: 16px;
        }
      }

      &-text {
        word-break: break-word;
        @include fontNormalText;
        @include linkStyle;
      }
    }
  }
</style>
